export const hasMinPasswordLength = (password: string) => password.length >= 6;
export const hasPasswordUpperLowerCase = (password: string) =>
  /[a-z]/.test(password) && /[A-Z]/.test(password);
export const hasPasswordNumberOrSymbols = (password: string) =>
  /[0-9]/.test(password) || /[^a-zA-Z0-9\s]/.test(password);

export const validatePassword = (password: string) => {
  return hasMinPasswordLength(password);
};
